// removed by extract-text-webpack-plugin
module.exports = {"pad-top":"_3BwQyUpRl1qhhT-OjG34Gn","amount-radio":"_1_ojMdrb3ji01B97Y9ikmj","amount-field":"_2FYUBnnQQWLe7UWty8Qb0n"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Contribution/styles.css
// module id = 1533
// module chunks = 0